<template>
  <div class="dd-amount-input" :class="{ error }">
    <div class="dd-amount-input__control">
      <input
        type="text"
        class="form-control dd-amount-input__field"
        :disabled="disabled"
        :error="error"
        :value="$store.getters.total"
        @input="input($event.target.value)"
      />
      <span class="dd-amount-input__suffix">{{ currencySymbol }}</span>
    </div>
    <p v-if="cryptoHint" class="dd-amount-input__hint">{{ cryptoHint }}</p>
  </div>
</template>
<script>
export default {
    name: "AmountInput",
    props: {
        value: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currencySymbol() {
            return this.$store.getters.currencySymbol;
        },
        cryptoHint() {
            const symbol = this.$store.getters.selectedCryptoCurrencySymbol;
            if (!symbol) {
                return null;
            }
            const multiplier = this.$store.getters.rateMultipliers?.[symbol];
            const total = this.$store.getters.total || 0;
            if (!multiplier || !total) {
                return null;
            }
            const precision = this.$store.getters.allowedCryptocurrencies?.[symbol]?.precision ?? 2;
            const converted = (total * multiplier).toFixed(precision);
            return `≈ ${converted} ${symbol}`;
        }
    },
    methods: {
        input(text) {
            text = text.replaceAll(/[^0-9]/g, '').replace(/^0+/, '').replace(/(......).*/, '$1');
            this.$store.dispatch('setTotal', (text == '') ? null : parseInt(text));
        },
    },
};
</script>
